import { NavigationItemInterface } from '../../../models/navigation-item.interface';

export class FavoritesStateToggleFavorite {
  static readonly type = '[FavoritesState] Toggle favorite';

  constructor(public favorite: NavigationItemInterface) {}
}
